import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default {
	name: 'work-features',
    from: {
		custom: ({ current, next, trigger }) => {
			const mobileBreakpoint = window.matchMedia('(max-width:991px)');
			if (mobileBreakpoint.matches) {
				return false;
			}
			return true;
		},
		namespace: ['template-work'],
	},
	to: {
		namespace: ['template-features'],
	},
	leave({ current, next, trigger }) {
		return new Promise(resolve => {

            document.dispatchEvent(new CustomEvent('disable-scroll'));
			current.container.classList.remove('ready-to-scroll');

			const color = next.container.dataset.color;
			const background = next.container.dataset.background;
			gsap.to(document.documentElement, {
				"--color": color,
				"--background": background,

				duration: 0.3,
				ease: 'none',
			});

			document.querySelector('[data-t-work]').classList.add('is-transitioning');

			const elementsToFadeOut = [];
			elementsToFadeOut.push(document.querySelector('[data-work-line]'));
			elementsToFadeOut.push(document.querySelector('[data-work-images]'));

			gsap.to(elementsToFadeOut, {
				opacity: 0,
				duration: 0.8,
				ease: 'none',
			});

			this.workItemTexts = current.container.querySelectorAll('[data-work-item-text]');
			gsap.to(this.workItemTexts, {
				opacity: 1,
				ease: 'sine.inOut'
			});

            gsap.to(current.container, {
				duration: 0.8,
                ease: 'power2.inOut',
				scrollTo: {
					y: 0
				},
				onComplete: () =>  {
					resolve();
				}
			});

			document.dispatchEvent(new CustomEvent('update-switcher', {
				detail: {
					namespace: next.namespace,
					duration: 0.8
			  	}
			}));

		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			gsap.set(next.container, {
				autoAlpha: 0,
			});

			gsap.set(current.container, {
				position: 'absolute',
				top: 0,
				left: 0,
				width: current.container.getBoundingClientRect().width,
				zIndex: -10,
			});

			resolve();

		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {

            gsap.set(next.container, {
                autoAlpha: 1,
            });

			gsap.set(current.container, {
                autoAlpha: 0,
				onComplete: () => {
					document.dispatchEvent(new CustomEvent('enable-scroll'));
					resolve();
				}
            });

		});
	}
};
